import { Icon } from "../icons/icon";

export const WebsiteAccordionTitle = ({
  number,
  title,
}: {
  number: string;
  title: string;
}) => {
  return (
    <div className="flex gap-4 items-center justify-between">
      <div className="flex items-baseline justify-center gap-6 font-medium ">
        <p className="text-purple-200 text-sm">{number}</p>
        <p className="text-xl lg:text-2xl">{title}</p>
      </div>

      <Icon
        svg="left-arrow"
        width={20}
        height={21}
        className={"rotate-180 text-purple-200"}
      />
    </div>
  );
};
